import { render, staticRenderFns } from "./icon_view.vue?vue&type=template&id=ad1b4b04"
import script from "./icon_view.vue?vue&type=script&lang=js"
export * from "./icon_view.vue?vue&type=script&lang=js"
import style0 from "./icon_view.vue?vue&type=style&index=0&id=ad1b4b04&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports